import { CheckCircle2, Clock, Search } from "lucide-react";

export const complaintsData = (isRtl: boolean) => {
  return {
    title: isRtl ? "الشكاوى والاقتراحات" : "Complaints & Suggestions",
    subtitle: isRtl
      ? "نحن هنا لنستمع إليك. تهمنا ملاحظاتك لتحسين جودة خدماتنا."
      : "We are here to listen. Your feedback helps us improve our services.",
    mechanismTitle: isRtl
      ? "آلية معالجة الشكاوى"
      : "Complaint Handling Mechanism",
    mechanismDesc: isRtl
      ? "نلتزم في منصة SNA العقارية بالشفافية والسرعة في حل مشكلاتك عبر الخطوات التالية:"
      : "At SNA Real Estate, we are committed to transparency and speed in resolving your issues through these steps:",
    steps: [
      {
        icon: <Clock className="w-6 h-6 text-blue-500" />,
        title: isRtl ? "1. استلام الطلب" : "1. Request Receipt",
        desc: isRtl
          ? "يتم استلام الشكوى وتسجيلها في نظامنا فوراً."
          : "Complaint is received and logged into our system immediately.",
        bg: "bg-blue-50 border-blue-100",
      },
      {
        icon: <Search className="w-6 h-6 text-amber-500" />,
        title: isRtl ? "2. المراجعة والتحقق" : "2. Review & Verification",
        desc: isRtl
          ? "يقوم الفريق المختص بمراجعة التفاصيل خلال 24 ساعة عمل."
          : "Our dedicated team reviews the details within 24 business hours.",
        bg: "bg-amber-50 border-amber-100",
      },
      {
        icon: <CheckCircle2 className="w-6 h-6 text-emerald-500" />,
        title: isRtl ? "3. المعالجة والرد" : "3. Resolution & Response",
        desc: isRtl
          ? "يتم اتخاذ الإجراء اللازم وإبلاغك بالنتيجة خلال 3 أيام."
          : "Necessary action is taken, and you are notified within 3 days.",
        bg: "bg-emerald-50 border-emerald-100",
      },
    ],
    form: {
      title: isRtl ? "نموذج التواصل" : "Contact Form",
      fullName: isRtl ? "الاسم الكامل" : "Full Name",
      email: isRtl ? "البريد الإلكتروني" : "Email Address",
      phone: isRtl ? "رقم الجوال" : "Phone Number",
      type: isRtl ? "نوع الطلب" : "Request Type",
      types: [
        isRtl ? "شكوى" : "Complaint",
        isRtl ? "اقتراح" : "Suggestion",
        isRtl ? "استفسار" : "Inquiry",
        isRtl ? "الإبلاغ عن إعلان مخالف" : "Report Violating Ad",
      ],
      subject: isRtl ? "موضوع الطلب" : "Subject",
      message: isRtl ? "تفاصيل الطلب" : "Message Details",
      submit: isRtl ? "إرسال الطلب" : "Submit Request",
      submitting: isRtl ? "جاري الإرسال..." : "Submitting...",
      successTitle: isRtl
        ? "تم إرسال طلبك بنجاح!"
        : "Request Submitted Successfully!",
      successDesc: isRtl
        ? "سيتم التواصل معك قريباً عبر البريد الإلكتروني أو الجوال."
        : "We will contact you shortly via email or phone.",
      required: isRtl ? "هذا الحقل مطلوب" : "This field is required",
      invalidEmail: isRtl ? "بريد إلكتروني غير صالح" : "Invalid email address",
    },
  };
};
